import { t } from "i18next";
import * as z from "zod";

import { ACCOUNT_TYPES } from "@/features/shared/api/enums";

/**
 * Schéma du formulaire d'un compte comptable
 * (`POST /ChartOfAccounts/add` / `PUT /ChartOfAccounts/{id}`, guide §6.4).
 *
 * Factory (règle projet) : créé via `createChartOfAccountSchema()` et
 * mémoïsé au niveau composant sur la langue courante.
 */
export const createChartOfAccountSchema = () =>
  z.object({
    code: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    label: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    accountType: z.enum(ACCOUNT_TYPES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    parentAccountId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") })
      .or(z.literal(""))
      .optional(),
    businessLine: z.string().trim().or(z.literal("")).optional(),
    isCommissionAccount: z.boolean(),
    currency: z
      .string()
      .trim()
      .regex(/^[A-Z]{3}$/, { message: t("invalidFieldError") }),
    isActive: z.boolean(),
  });

export type ChartOfAccountFormValues = z.infer<
  ReturnType<typeof createChartOfAccountSchema>
>;
